<template>
    <div>
        <el-table
            :data="tableData"
            border
            style="width: 100%;
                margin-top:20px;">
            <el-table-column prop="createdAt" :label="$t('Common.time')" />
            <el-table-column prop="type" :label="$t('Setting.export_con')" />
            <el-table-column prop="remark" :label="$t('Setting.export_state')" >
                <template slot-scope="{row}">
                    {{ row.remark }}
                    <span
                        class="cursor-pointer"
                        @click="exportForm(row.url)"
                        v-if="row.statusCode === 2">
                        {{ $t('Setting.DownloadReport') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="exportCount" :label="$t('Setting.export_data')" />
            <el-table-column prop="operatorStaffNickname" :label="$t('Reception.Third.people')" />
        </el-table>
        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right mt-10"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'export-history',
    data() {
        return {
            tableData: [],
            pagination: {
                size: 50,
                total: 0,
                page: 1,
            },
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            API.get('export/history', {
                params: {...this.pagination},
            }).then((res) => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            });
        },
        exportForm(url) {
            window.open(url);
        },
    },
}
</script>
